



















































import Vue from 'vue';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import PropertyResultsMap from './property-results-map.vue';
import PropertyResultsCards from './property-results-cards.vue';
import { Constants } from "@/api-constants";
import { API } from "aws-amplify";
import { getModule } from "vuex-module-decorators";
import FavouritesModule from "@/store/Favourites";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { Choice } from "@/api/model/Choice";
import DecisionModule from "@/store/decision/Decision";
import { Decision } from "@/api/model/Decision";
import UserAuth from "@/store/auth/UserAuth";
import Favourites from "@/store/Favourites";
import { Component } from "vue-property-decorator";
import AuthLogin from "@/components/auth/auth-login.vue";
import ViewpointSelector from "@/components/common/viewpoint-selector.vue";

@Component({
  components: {
    'property-results-map': PropertyResultsMap,
    'property-results-cards': PropertyResultsCards,
  }
})
export default class PropertyUserFavourites extends Vue {

  erroredGet = false
  factorGroups = {} as any
  pageSize = 18
  pageOffset = 0
  changeSort = 'rank'
  changeSorts = [
    {text: 'Scores', value: 'score'},
    {text: 'Custom Rank', value: 'rank'},
  ]
  changeView = 'list'
  changeViews = [
    {text: 'Tile View', value: 'tile'},
    {text: 'List View', value: 'list'},
  ]


  get decision(): Decision | null | undefined {
    return getModule(DecisionModule).decision
  }

  get favourites(): string[] {
    return getModule(FavouritesModule).favouriteIds
  }

  get idToken(): any {
    return getModule(UserAuth).user
  }

  get titleSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return 'title';
      default:
        return 'headline';
    }
  }

  get factors() {
    return getModule(DecisionModule).factors
  }

  get choices() {
    return getModule(FavouritesModule).favourites
  }

  get choicesScores() {
    return getModule(FavouritesModule).favouritesScores
  }

  get sortedScores() {
    if (this.changeSort === 'score') {
      return this.favourites
          .filter(id => this.choicesScores[id] && this.choices[id])
          .map(id => this.choicesScores[id])
          .sort((a, b) => a.score - b.score)
    }
    return this.favourites.filter(id => this.choicesScores[id] && this.choices[id])
        .map(id => this.choicesScores[id])

  }


}

